export default class ActionButtonModel {
  constructor(id, title) {
    this.id = id ?? 0;
    this.title = title ?? "";
  }
}
